module.exports = __webpack_public_path__ + "img/shape-metal_af@2x.aa7a62e6.png";